<template>
    <div class="flex w-full justify-center bg-gray-100">
        <div
            class="relative flex min-h-screen w-full max-w-(--breakpoint-2xl) flex-col items-center py-6 sm:justify-center"
        >
            <div>
                <Logo />
            </div>

            <div class="right-[20px] top-[20px] mt-5 sm:absolute sm:mt-0">
                <a href="https://topol.io/">
                    <AtomicButton size="md" color="yellow">
                        Go to homepage
                    </AtomicButton>
                </a>
            </div>

            <slot />
        </div>

        <Notifications />
    </div>
</template>
